import React from 'react';
import { Link } from 'react-router-dom';
import leftImage from '../assets/images/banner2.png';
import rightImage from '../assets/images/banner.jpg';
import formacoopLogo from '../assets/logo/formacoop-logo.png';
import qualiopiLogo from '../assets/logo/LogoQualiopi-300dpi-Avec-Marianne.png';
import moduleStandardImg from '../assets/images/module_standard_hmf.png';
import moduleJeuneImg from '../assets/images/module_jeune_hmf.png';

const Home = () => {
  return (
    <div className="home-page">
      {/* Hero Section */}
      <section className="hero-section">
        <div className="container">
          <div className="hero-content">
            <h1 className="hero-title">HELP MIND FORMATION</h1>
            <p className="hero-subtitle">
              Formations reconnues en Premiers Secours en Santé Mentale,
              pour mieux repérer, comprendre et accompagner les personnes en difficulté.
            </p>
            <Link to="/contact" className="btn btn-primary" style={{fontSize: '1.2rem', padding: '15px 40px'}}>
              CONTACTEZ-MOI
            </Link>
          </div>

          <div className="hero-images">
            <img src={leftImage} alt="Visages Vibrants" className="hero-img" style={{maxWidth: '100%'}} />
          </div>
        </div>
      </section>

      {/* Modules Section */}
      <section className="section text-center">
        <div className="container">
          <h2>NOS FORMATIONS</h2>
          <div className="grid-2">
              <div className="card">
                  <img src={moduleStandardImg} alt="Module Standard" className="card-img" />
                  <h3>MODULE STANDARD - ADULTE</h3>
                  <p>
                      Cette formation vous apprend à reconnaître les signes de détresse psychologique, 
                      à mieux comprendre les troubles courants (dépression, anxiété, psychose, addictions) 
                      et à intervenir de manière adaptée grâce au plan d’action AERER.
                  </p>
                  <div style={{marginTop: 'auto'}}>
                    <Link to="/module-standard" className="btn">EN SAVOIR PLUS</Link>
                  </div>
              </div>
              <div className="card">
                  <img src={moduleJeuneImg} alt="Module Jeune" className="card-img" />
                  <h3>MODULE JEUNE</h3>
                  <p>
                      Spécialement conçu pour les professionnels en contact avec les jeunes, 
                      ce module aborde le développement de l’adolescent, les troubles spécifiques à cet âge 
                      (dépression, anxiété, conduites alimentaires, addictions, psychose) 
                      et l’importance de l’intervention précoce.
                  </p>
                  <div style={{marginTop: 'auto'}}>
                    <Link to="/module-jeune" className="btn">EN SAVOIR PLUS</Link>
                  </div>
              </div>
          </div>
        </div>
      </section>

      {/* Why Choose Us Section */}
      <section className="section section-bg text-center">
        <div className="container">
          <h2>POURQUOI CHOISIR CES FORMATIONS ?</h2>
          <div className="grid-4">
              <div className="feature-box">
                  <div className="card-icon">👁️</div>
                  <h3>RECONNAÎTRE LES SIGNES</h3>
                  <p>Développez votre capacité à identifier les premiers signaux de détresse psychologique chez les adultes et les jeunes.</p>
              </div>
              <div className="feature-box">
                  <div className="card-icon">🤝</div>
                  <h3>INTERVENIR EFFICACEMENT</h3>
                  <p>Apprenez à appliquer le plan d’action AERER pour soutenir une personne en difficulté et l’orienter vers les bonnes ressources.</p>
              </div>
              <div className="feature-box">
                  <div className="card-icon">⏰</div>
                  <h3>AGIR AU BON MOMENT</h3>
                  <p>Comprenez l’importance de l’intervention précoce pour limiter les conséquences des troubles psychiques.</p>
              </div>
              <div className="feature-box">
                  <div className="card-icon">🎓</div>
                  <h3>UNE FORMATION RECONNUE</h3>
                  <p>Nos formations s’inscrivent dans le dispositif officiel des Premiers Secours en Santé Mentale, soutenu par l’État et PSSM France.</p>
              </div>
          </div>
        </div>
      </section>

      {/* Financing Section */}
      <section className="container">
        <div className="financing-section text-center">
          <h3>FINANCEMENTS & PRISE EN CHARGE</h3>
          <ul className="financing-list">
              <li><strong>Entreprises :</strong> financement possible via votre OPCO (selon votre accord de branche et votre politique interne) et/ou votre Plan de développement des compétences. Nous vous accompagnons pour constituer le dossier (devis, programme, convention, attestation de réalisation).</li>
              <li><strong>Établissements scolaires & associations :</strong> financement par le budget établissement, la collectivité/autorité de tutelle ou via des appels à projets (prévention, santé, QVCT, climat scolaire).</li>
              <li><strong>Formats :</strong> intra (dans vos locaux) ou inter (regroupement de participants). Devis personnalisé selon vos besoins (taille du groupe, calendrier, logistique).</li>
          </ul>
        </div>
      </section>

      {/* Compliance Section */}
      <section className="section">
        <div className="container">
          <div className="compliance-section">
            <div style={{flex: 1}}>
                <h3 style={{textAlign: 'left', marginBottom: '10px', fontSize: '1.2rem'}}>ENGAGEMENT QUALITÉ</h3>
                <p style={{marginBottom: 0}}>Membre de la coopérative Formacoop, nous pouvons vous proposer des formations certifiées Qualiopi, gage de qualité et de professionnalisme.</p>
            </div>
            <div className="compliance-logos">
                <img src={formacoopLogo} alt="Formacoop" title="Formacoop" />
                <img src={qualiopiLogo} alt="Qualiopi" title="Qualiopi" />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
